import { Component } from "react";

import { Stack, Button } from "@mui/material";

import _ from "lodash";
import { configureValues, arrangeModels } from "models/Game";
import ESGSort from "components/ESGSort";

const round_template = {
  name: "...",
  matchValue: 0,
  current_round: 0,
  total_rounds: 1,
  current_state: [],
  shuffle: true,
};

// coordinates loading the game and presenting it
class Play extends Component {
  constructor({ game, round, onSubmit, config }) {
    super();
    this.onSubmit = onSubmit;
    this.shuffle = config?.shuffle ?? false;
    this.state = {
      title: config?.name,
      game: game, // wait for game to load
      round: round,
      round_config: { ...round_template },
    };
  }

  componentDidMount() {
    this.initializeGameRound();
  }

  // receive changes from the list of sliders and apply them to state
  handleDataChange = (data) => {
    var rc = this.state.round_config;
    if (!rc) return;
    rc.current_state = [...data];
    this.setState({ round_config: rc });
  };

  set_profile = (profile) => this.setState({ profile: profile });
  set_submission = (newSubmission, nextRound) => {
    this.onSubmit(newSubmission);
  };

  initializeGameRound = () => {
    const { game, round, model_map } = this.state;

    if (!game) return console.warn("Failed to initialize game round. No game is mounted");

    let name = game.name || "unnamed game";
    let all_game_rounds = game.rounds;

    let current_game_round = all_game_rounds[round];
    if (!current_game_round) console.warn("Failed to initialize game round. No rounds to select");

    var data = configureValues(
      current_game_round.matchValue,
      arrangeModels({
        models: current_game_round.models,
        model_map: model_map,
      })
    );

    data = this.shuffle ? _.shuffle(data) : data.sort((a, b) => a.name.localeCompare(b.name));

    let rc = {
      name: name,
      prompt: current_game_round.prompt ?? current_game_round.title,
      matchValue: current_game_round.matchValue,
      current_round: round,
      total_rounds: all_game_rounds.length,
      initial_state: [...data],
      current_state: _.cloneDeep([...data]),
    };

    this.setState({ round_config: rc });
  };

  render() {
    const { round_config } = this.state;
    const updateData = (data) => this.handleDataChange(data);
    // const randomize = () => this.initializeGameRound();
    const setupGame = () => {
      let data = configureValues(round_config.matchValue, round_config.models);
      updateData(data);
    };

    const handle_submit = () => {
      this.set_submission(
        {
          name: round_config.prompt ?? round_config.mode ?? round_config.type,
          initial_state: round_config.initial_state,
          final_state: round_config.current_state,
        },
        setupGame
      );
    };

    // Actions to perform on the current game round
    const ActionsFooter = () => {
      return (
        <Stack gap={1}>
          {/* <Button variant="outlined" onClick={randomize}>
            Randomize
          </Button> */}
          <Button variant="contained" onClick={handle_submit}>
            Next
          </Button>
        </Stack>
      );
    };

    // Render the game scene
    return (
      <>
        {round_config.prompt && (
          <Stack
            alignContent="center"
            justifyContent="center"
            sx={{ textAlign: "center", pb: 2 }}
          >
            <h2>{round_config.prompt}</h2>
          </Stack>
        )}

        {/* Rows of models w/ sliders */}
        <div className="row p-4">
          <h6 className="text-success py-2">Highest Priority</h6>
          <ESGSort
            data={round_config.current_state}
            total={round_config.matchValue}
            onReorder={updateData}
          />
          <h6 className="text-danger py-1">Lowest Priority</h6>
        </div>
        <ActionsFooter />
      </>
    );

    // return (
    //   <>

    //     <SortGameView
    //       config={round_config}
    //       setup={this.initializeGameRound}
    //       onChange={this.handleDataChange}
    //       onSubmit={this.set_submission}
    //     />
    //   </>
    // );
  }
}

export default Play;
